export default {
  namespaced: true,
  state() {
    return {
      clickTrade: false,
      btnTrade: false,
      clickBuy: true,
      clickSell: false,
      slider: 0,
    };
  },
  mutations: {
    changeTrade(state, payload) {
      state.clickTrade = payload.state;
    },
    changeBtnTrade(state, payload) {
      state.btnTrade = payload.state;
    },
    changeBuy(state, payload) {
      state.clickBuy = payload.state;
    },
    changeSell(state, payload) {
      state.clickSell = payload.state;
    },
    setSlider(state, value) {
      state.slider = value;
    },
  },
  actions: {},
};
